import { createContext, useContext } from 'react';

import type { UserRead } from '../../api/types';

export type AuthStatus = 'loading' | 'authenticated' | 'error';

export interface AuthContextValue {
  status: AuthStatus;
  user: UserRead | null;
  retry: () => void;
  // PARA-132 (AC-7) — единственный способ заменить пользователя внутри сессии:
  // POST /users/me/voice-consent возвращает обновлённый UserRead, и статус
  // согласия обязан отразиться в контексте без повторного логина.
  applyUser: (user: UserRead) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
